<script setup lang="ts">
import {useWindowSize} from "@vueuse/core";
import {computed} from "vue";
import {useYachtStore} from "@/stores/yachtStore";
import {useFormatStore} from "@/stores/formatStore";

defineProps({
  yacht: {
    type: Object,
    required: true
  }
})

const yachtStore = useYachtStore();
const formatStore = useFormatStore();

const { width } = useWindowSize();
const isSmall = computed(() => width.value < 1024);
const isMobile = computed(() => width.value < 768);
</script>

<template>

  <div
      class="flex flex-col sm:flex-row sm:justify-between sm:items-center py-5 px-5 bg-background-beige mb-2 cursor-pointer"
      @click="yachtStore.viewYachtDetails(yacht.slug)"
  >
    <!-- Left: Image + Text -->
    <div class="flex items-center gap-4">
      <img
          :src="yacht?.images.length > 0 ? yacht?.images[0]['original'] : yacht?.image_main['original']"
          alt="Yacht image"
          class="w-20 h-20 object-cover flex-shrink-0"
      />
      <div class="flex flex-col">
      <span class="font-bold responsive-body-large text-primary-darkBlue">
        {{ yacht.name }}
      </span>
        <span class="responsive-body-small text-bw-midGrey uppercase">
        {{ yacht.category }}
      </span>
      </div>
    </div>

    <div v-if="!isMobile" class="flex flex-col text-center responsive-body-small text-primary-violet gap-1">
      <!-- Length -->
      <div class="flex items-center gap-2">
        <img src="@/assets/icons/length.png" alt="Length icon" class="sm:w-auto sm:h-auto" />
        <div class="flex responsive-body-xsmall items-center sm:items-start gap-1">
          <p class="font-bold text-primary-darkBlue">{{ yacht.lengthOverall }}</p>
          <span>Length (m)</span>
        </div>
      </div>

      <!-- Cabins -->
      <div class="flex items-center gap-2">
        <img src="@/assets/icons/cabins.svg" alt="Cabins icon" class="w-5 h-5" />
        <div class="flex responsive-body-xsmall items-center sm:items-start gap-1">
          <p class="font-bold text-primary-darkBlue">{{ yacht.cabins }}</p>
          <span>Cabins</span>
        </div>
      </div>

      <!-- Berths -->
      <div class="flex items-center gap-2">
        <img src="@/assets/icons/berths.svg" alt="Berths icon" class="w-5 h-5 mt-0.5 sm:mt-0" />
        <div class="flex responsive-body-xsmall items-center sm:items-start gap-1">
          <p class="font-bold text-primary-darkBlue">{{ yacht.berths }}</p>
          <span>Berths</span>
        </div>
      </div>
    </div>


    <!-- Price block -->
    <div :class="['responsive-body-small', isMobile ? 'mt-4' : '']">
      <p class="text-bw-midGrey flex items-center gap-1">
        <img src="@/assets/icons/price.png" alt="Price logo" />
        <span>PRICE/WEEK FROM</span>
      </p>
      <p class="responsive-body-xlarge font-bold text-primary-darkBlue mt-1">
        {{ formatStore.formatPrice(yacht.price) }}
      </p>
    </div>
  </div>


</template>

<style scoped>

</style>
